import api, { getData, post, put, deleteData } from 'services/api';
import {
	CommitResponse,
	EventSuggestionsResponse,
	PreviewResponse,
	TicketImport,
	UpdateMappingPayload,
	UploadResponse,
} from './types';

const BASE = '/ticket-imports';

export const uploadTicketImport = async (file: File, sourcePlatform?: string): Promise<UploadResponse> => {
	const formData = new FormData();
	formData.append('file', file);
	if (sourcePlatform) {
		formData.append('source_platform', sourcePlatform);
	}
	const { data } = await api.post(BASE, formData);
	return data;
};

export const getTicketImport = async (id: number): Promise<TicketImport> => {
	return getData(`${BASE}/${id}`);
};

export const listTicketImports = async (params?: { status?: string; limit?: number }): Promise<TicketImport[]> => {
	const qs = new URLSearchParams();
	if (params?.status) qs.set('status', params.status);
	if (params?.limit) qs.set('limit', String(params.limit));
	const suffix = qs.toString() ? `?${qs.toString()}` : '';
	return getData(`${BASE}${suffix}`);
};

export const updateTicketImportMapping = async (id: number, payload: UpdateMappingPayload): Promise<TicketImport> => {
	return put(`${BASE}/${id}/mapping`, payload);
};

export const getEventSuggestions = async (id: number): Promise<EventSuggestionsResponse> => {
	return getData(`${BASE}/${id}/event-suggestions`);
};

export const previewTicketImport = async (id: number): Promise<PreviewResponse> => {
	return post(`${BASE}/${id}/preview`, {});
};

export const commitTicketImport = async (id: number): Promise<CommitResponse> => {
	return post(`${BASE}/${id}/commit`, {});
};

export const deleteTicketImport = async (id: number): Promise<void> => {
	return deleteData(`${BASE}/${id}`);
};
